import { netherlandsHttpService } from '../../services'
import { Unauthorized } from '../../helpers/unauthorized.handler'
export const UserModule = {
    namespaced: true,
    state : {
        endpoint : 'user',
    },
    actions : {

        async checkToken({ dispatch },token) {
            return await new Promise((resolve) => {
                netherlandsHttpService.getToken(token).then((response) => {
                    resolve(response.data)
                }).catch(error => {
                    Unauthorized(dispatch, error)
                })
            })
        },

        async authToken({ dispatch },token) {
            return await new Promise((resolve) => {
                netherlandsHttpService.getToken(token).then((response) => {
                    resolve(response)
                }).catch(error => {
                    Unauthorized(dispatch, error)
                })
            })
        },
    },
   
}


